import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Dossier, Fitter } from '@sc/data-access-models';

export class DossierInterventionValidator {
  static interventionMobilityConsistency(
    getCurrentFitterFn: () => Fitter
  ): ValidatorFn {
    const fn = (control: AbstractControl): { [key: string]: boolean } => {
      const dossier: Dossier = control?.value;

      const currentFitter = getCurrentFitterFn();
      const foundIntervention = (currentFitter?.serviceTypes || []).find(
        (serviceType) => serviceType.id === dossier?.appointment?.interventionId
      );

      if (
        !foundIntervention?.canMakeInCenterIntervention &&
        !dossier?.appointment?.outsideIntervention
      ) {
        return {
          cannot_have_in_center_appointment: true,
        };
      }

      if (
        !foundIntervention?.canMakeOutsideIntervention &&
        dossier?.appointment?.outsideIntervention
      ) {
        return {
          cannot_have_outside_appointment: true,
        };
      }

      return null;
    };

    return fn;
  }
}
